import { MeasureComponent, type MeasureComponentProps, type MeasureComponentState } from "@component/MeasureComponent";
import { faChevronRight as fasChevronRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import autobind from "autobind-decorator";
import { PromisePool } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";

interface Props extends MeasureComponentProps {
	onShow?(show: boolean): void;
}

interface State extends MeasureComponentState {
	showModal: boolean;
	showButton: boolean;
	isOnTop: boolean;
}

export class ScrollButton extends MeasureComponent<Props, State> {
	private static defaultState: Partial<State> = {};
	private readonly promisePool = new PromisePool();

	protected getInitialState(): State {
		return {
			...super.getInitialState(),
			showModal: false,
			showButton: false,
			isOnTop: this.isTop(),
			...ScrollButton.defaultState,
		};
	}

	public componentDidMount(): void {
		this.setState(ScrollButton.defaultState as State);
		this.addListeners();
	}

	private addListeners(): void {
		window.addEventListener("scroll", this.onScroll, { passive: true });
	}

	public componentWillUnmount(): void {
		this.promisePool.cancel();

		window.removeEventListener("scroll", this.onScroll);
	}

	public render(): ReactNode {
		const { isOnTop } = this.state;

		if (isOnTop) {
			return null;
		}

		return (
			<a className="back-top" href="#top" aria-label="Ugrás az oldal tetejére" onClick={this.onBackToTopClick}>
				<FontAwesomeIcon icon={fasChevronRight} rotation={270} fixedWidth />
			</a>
		);
	}

	@autobind
	private onScroll(): void {
		const { showButton } = this.state;
		const isTop = this.isTop();

		this.setState({
			isOnTop: isTop,
		});

		if (!isTop && !showButton) {
			this.setState({
				showButton: true,
			});
		}
	}

	@autobind
	private onBackToTopClick(): void {
		GoogleAnalytics4.sendEvent("BM_scrollTo", {
			buttonName: "toTopButton",
		});
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}

	private isTop(): boolean {
		const height = window.innerHeight * 0.75;

		return Math.max(document.body.scrollTop, document.documentElement.scrollTop) < height;
	}

	protected getComponentName(): string {
		return "ScrollButton";
	}
}
